import React ,{useEffect} from 'react';
import AOS from 'aos';
import ContactForm from '../Components/Pages/ContactUs/ContactForm';
import Header from '../Components/Shared/Header/Header';
import Footer from '../Components/Shared/Footer/Footer';
function ContactUs(){
    useEffect(() => {
        AOS.init({
          duration: 800,
          disable: 'mobile',
          once: true,
        });
      }, []);
    return(
        <>
        <Header styles="scrolled"/>
        <ContactForm />
        <Footer />
        </>
    )
};
export default ContactUs;